import { useLocale } from '../common/locale';
import { IconCritical, IconInformation, IconNotification, IconPositive, IconWarning } from '@op/opds.opux-icons/indicator';
import React from 'react';
import { iconAriaLabelTexts } from './_messages';
const AlertIcon = _ref => {
  let {
    embedded,
    flash,
    icon,
    iconlabel,
    id,
    inline,
    style,
    type
  } = _ref;
  let iconColor = 'notification';
  const lc = useLocale();
  const constructAriaLabelText = type => {
    return iconlabel != null ? iconlabel : iconAriaLabelTexts[lc][type];
  };
  const size = (() => {
    switch (true) {
      case embedded || inline === 'large':
        return 'default';
      case inline || flash:
        return 'small';
      default:
        return 'large';
    }
  })();
  let AlertWithIcon = icon;
  if (!icon) {
    switch (type) {
      case 'critical':
        AlertWithIcon = IconCritical;
        // Icon doesn't have 'critical' but uses 'negative' for the color instead
        iconlabel = constructAriaLabelText(type);
        iconColor = 'negative';
        break;
      case 'information':
        AlertWithIcon = IconInformation;
        // Icon doesn't have 'information' but uses 'default' for the color instead
        iconlabel = constructAriaLabelText(type);
        iconColor = 'default';
        break;
      case 'positive':
        AlertWithIcon = IconPositive;
        iconlabel = constructAriaLabelText(type);
        iconColor = 'positive';
        break;
      case 'warning':
        AlertWithIcon = IconWarning;
        iconlabel = constructAriaLabelText(type);
        iconColor = 'warning';
        break;
      default:
        AlertWithIcon = IconNotification;
        iconlabel = iconlabel != null ? iconlabel : iconAriaLabelTexts[lc].notification;
        break;
    }
  }
  return AlertWithIcon ? /*#__PURE__*/React.createElement(AlertWithIcon, {
    color: iconColor,
    id: id,
    label: iconlabel,
    size: size,
    style: style
  }) : null;
};
export default AlertIcon;